import { gql } from '@apollo/client';

export const UNSEEN_PLACEMENT_CELEBRATIONS = gql`
  query UnseenPlacementCelebrations {
    unseenPlacementCelebrations {
      id
      candidateName
      jobTitle
      clientName
      salaryFormatted
      salaryLabel
      accountManagerName
      recruiterName
      createdAt
    }
  }
`;

export const MARK_PLACEMENT_CELEBRATIONS_SEEN = gql`
  mutation MarkPlacementCelebrationsSeen($celebrationIds: [String!]!) {
    markPlacementCelebrationsSeen(celebrationIds: $celebrationIds) {
      message
      status
    }
  }
`;
